import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Protege rutas del frontend.
 *
 * - Sin sesión (token) -> redirige a /login.
 * - Con `allowedRoles` y un rol no permitido -> redirige a la "casa" del usuario
 *   según su rol (evita que, por ejemplo, un Cliente entre a /admin escribiendo la URL).
 *
 * Nota: esto es una capa de UX. La seguridad real la impone el backend (guards de rol
 * en NestJS); el token se valida en cada petición.
 */
function getStoredUser() {
    try {
        const raw = localStorage.getItem('user');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

function homeForRole(rol) {
    if (rol === 'Admin') return '/admin';
    if (rol === 'Empleado') return '/dashboard-empleado';
    return '/bienvenida';
}

export default function ProtectedRoute({ children, allowedRoles }) {
    const token = localStorage.getItem('token');
    const user = getStoredUser();

    // 1. No autenticado
    if (!token || !user) {
        return <Navigate to="/login" replace />;
    }

    // 2. Autenticado pero sin el rol requerido
    if (allowedRoles && !allowedRoles.includes(user.rol)) {
        return <Navigate to={homeForRole(user.rol)} replace />;
    }

    return children;
}
